module.exports = __webpack_public_path__ + "static/media/RECORD.5ec34189.gif";